const styles = {
    qrCodeIcon: {
        position: 'absolute',
        right: 92,
    },
    rightIcon: {
        position: 'absolute',
        right: 50
    },
    rightVisibleIcon: {
        position: 'absolute',
        right: 10,
    },
    modal: {
        top: 0,
        padding: 0,
        width: '570px',
        height: '600px'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/openexplore/TrailInfo/TrailInfo.css.js